export var prefix = '{{';
export var suffix = '}}';
//# sourceMappingURL=variable-placeholders.js.map